import React, {
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
  useContext,
} from "react";
import { SimpleDialog, Button } from "simple-ui-components";

import SyncAltIcon from "@mui/icons-material/SyncAlt";

import { AuthContext } from "../authContextProvider";
import FormHooks from "../shared/formHooks";
import { FirebaseChangePassword } from "../../firebase";
import { WarnToLogout } from "../shared/warning";
import { getTranslation } from "../languageProvider";
import { selectNextOnEnter, UpdateInputChange } from "../shared/utility";

export const ChangePassword = forwardRef((props, ref) => {
  const submitRef = useRef();
  const oldPasswordRef = useRef();
  const newPasswordRef = useRef();
  const repeatPasswordRef = useRef();
  const warnToLogout = useRef();

  const { Dialog, DialogBody, DialogFooter } = SimpleDialog;
  const { user, snackbarHandler } = useContext(AuthContext);

  const [open, setOpen] = useState(false);
  const [formInputs, setFormInputs] = useState({
    password: {
      type: "password",
      label: "0054",
      inputRef: oldPasswordRef,
      input: {
        type: "password",
        name: "password",
        autoComplete: "old_password",
        id: "password",
        onKeyDown: (e) => selectNextOnEnter(e, newPasswordRef),
      },
      value: "",
      validation: {
        required: true,
        min: 6,
        notEqual: "newPassword",
      },
      valid: false,
      touched: false,
    },
    newPassword: {
      type: "password",
      label: "0055",
      inputRef: newPasswordRef,
      input: {
        type: "password",
        name: "new_password",
        autoComplete: "new_password",
        id: "new_password",
        onKeyDown: (e) => selectNextOnEnter(e, repeatPasswordRef),
      },
      value: "",
      validation: {
        required: true,
        min: 6,
        notEqual: "password",
        equal: "confirmPassword",
      },
      valid: false,
      touched: false,
    },
    confirmPassword: {
      type: "password",
      label: "0056",
      inputRef: repeatPasswordRef,
      input: {
        type: "password",
        name: "repita_password",
        autoComplete: "repita_password",
        id: "repita_password",
        onKeyDown: (e) => selectNextOnEnter(e, submitRef),
      },
      value: "",
      validation: {
        required: true,
        min: 6,
        equal: "newPassword",
      },
      valid: false,
      touched: false,
    },
    submit: {
      isSubmit: false,
      valid: false,
    },
  });

  const handleClose = () => setOpen(false);

  // trigger from props
  useImperativeHandle(ref, () => ({
    ChangePassword() {
      setOpen(true);
    },
  }));

  const changePasswordHandler = (e) => {
    if (formInputs.submit.valid && user) {
      e.preventDefault();
      let email = user.email;
      let oldPassword = oldPasswordRef.current.value;
      let newPassword = newPasswordRef.current.value;

      FirebaseChangePassword(email, oldPassword, newPassword)
        .then(() => {
          setOpen(false);
          let message = {
            success: getTranslation("0065"),
            warning: getTranslation("0066"),
          };
          warnToLogout.current.Message(message);
          setOpen(false);
        })
        .catch((status) => {
          if (status === 401) {
            snackbarHandler(getTranslation("0058"));
          } else {
            snackbarHandler(getTranslation(`error${status}`));
          }
        });
    }
  };

  const inputChangeHandler = (e, key) =>
    setFormInputs(UpdateInputChange(formInputs, e.target.value, key));

  return (
    <>
      {open && (
        <Dialog
          theme="default"
          size="sm"
          close={handleClose}
          open={open}
          title={getTranslation("0053")}
        >
          <DialogBody>
            <FormHooks
              formInputs={formInputs}
              inputChange={inputChangeHandler}
              onSubmit={changePasswordHandler}
              size="md"
              layout="outline"
            />
          </DialogBody>
          <DialogFooter multiple={true}>
            <Button
              type="button"
              clicked={changePasswordHandler}
              icon={<SyncAltIcon />}
              text={getTranslation("0057")}
              className={
                formInputs.submit.valid ? "btn-primary" : "btn-disabled"
              }
              theme={formInputs.submit.valid ? "primary" : "disabled"}
              style={{ marginLeft: "auto" }}
            />
          </DialogFooter>
        </Dialog>
      )}

      <WarnToLogout ref={warnToLogout} />
    </>
  );
});
